import React, { useEffect, useState } from 'react'

import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

import imgLogo from "../../img/logo.svg";

import "../../css/navbar.css"

const Navbar = (props) => {
    const [resources, setResources] = useState({});
    const [scrollingUp, setScrollingUp] = useState(true);

    let navigate = useNavigate();

    const { language } = useParams();


    useEffect(() => {

        let lastScrollY = window.pageYOffset;

        const handleScroll = () => {
            if (window.pageYOffset > lastScrollY) {
                setScrollingUp(false); // User is scrolling down
            } else {
                setScrollingUp(true); // User is scrolling up
            }
            lastScrollY = window.pageYOffset;
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        requestResources();

        //set the html lang property
        document.documentElement.lang = language;
    }, [language]);

    // Load Cookiebot
    useEffect(() => {

        const cookiebotId = "ef207804-58ef-4e83-a08d-7f643ad5a6ed" //live
        //const cookiebotId = "8e8ff182-b8b7-4afe-ad5b-6474413f6cf9" //stage

        if (!document.getElementById("Cookiebot")) {
            const script = document.createElement("script");
            script.id = "Cookiebot";
            script.src = "https://consent.cookiebot.com/uc.js";
            script.setAttribute("data-cbid", cookiebotId);
            script.setAttribute("data-blockingmode", "auto");
            script.setAttribute("data-culture", language);
            script.type = "text/javascript";
            script.async = true;

            document.head.appendChild(script);

            script.onload = () => {
                // Wait for Cookiebot to be initialized before accessing it
                const checkCookiebot = setInterval(() => {
                    if (window.Cookiebot && window.Cookiebot.consents) {
                        clearInterval(checkCookiebot);
                        if (window.Cookiebot.consents.given) {
                            console.log('User has already accepted cookies.');
                        } else {
                            console.log('User has not accepted cookies yet.');
                        }
                    }
                }, 100); // Check every 100ms until Cookiebot is available
            };
        }
    }, []);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.informationAndTariff);
            })
            .catch((error) => console.error(error.response.data));
    };

    const navigateToShipping = async () => {

        // gtm - view_cart
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'view_cart'
        });

        navigate(`/${language}/shipping`);
    }

    let languageNavPath = props.pagePath;

    if (props.eventId > 0) {
        languageNavPath = props.pagePath + "/" + props.eventId
    }

    const onLanguageClick = (lang) => {
        // Navigate to the new language page
        navigate(`/${lang}/${languageNavPath}`);

        // Reload the page to reflect the new language settings
        window.location.reload();
    };

    return (
        <>
            <div className={`navbar-container ${scrollingUp ? 'navbar-visible' : 'navbar-hidden'}`}>
                {/* Navbar */}
                <nav className="navbar navbar-dark bg-dark">
                    <div className="container-fluid page-wrapper">
                        <a className="navbar-brand" href={`/${language}/home`}>
                            <div className="navbar-brand-img">
                                <img className="navbar-brand-img" src={imgLogo} alt="Kunsthaus Zurich" style={{width: "315px", maxWidth: "100%", transform: "translateZ(0)"}} />
                            </div>
                            <svg className="navbar-brand-img-mobile align-items-center justify-content-end" xmlns="http://www.w3.org/2000/svg" width="35" height="30" viewBox="0 0 1000 800">
                                <g id="Ebene_1">
                                    <polygon
                                        className="cls-1"
                                        points="812.1 704.9 999 704.9 648.6 392.2 946.9 126.3 769 126.3 531.8 340.1 373.7 340.1 373.7 126.3 246.1 126.3 246.1 704.9 373.7 704.9 373.7 449.7 526.4 449.7 812.1 704.9"
                                        style={{ fill: '#fff' }}
                                    />
                                </g>
                            </svg>
                        </a>
                        <div className="navbar-center d-flex align-items-center justify-content-end" style={{ height: "100%" }}>
                            <span className="nav-title">Tickets</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-end">
                            {props.isShoppingCartVisible &&
                                <div className="d-flex align-items-center justify-content-end">
                                    <div className={`nav-shop-basket-container ${props.numberOfTickets > 0 ? 'cursor-pointer' : ''}`}
                                        onClick={props.numberOfTickets > 0 ? (e) => navigateToShipping() : undefined}>
                                        <svg fill="#ffffff" className="nav-shop-basket" viewBox="0 -32 576 576" xmlns="http://www.w3.org/2000/svg"><path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z" /></svg>
                                    </div>
                                    {props.numberOfTickets > 0 &&
                                        <span className="cart-quantity">
                                            {props.numberOfTickets}
                                        </span>
                                    }
                                </div>
                            }
                            <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasMenu" aria-controls="offcanvasMenu">
                                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="16" viewBox="0 0 35 16">
                                    <rect x="0" y="0" width="35" height="2" fill="#fff" />
                                    <rect x="0" y="7" width="35" height="2" fill="#fff" />
                                    <rect x="0" y="14" width="35" height="2" fill="#fff" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </nav>

            </div>

            {/* Offcanvas Sidebar - outside navbar-container to avoid transform stacking context */}
            <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasMenu" aria-labelledby="offcanvasMenuLabel">
                    <div className="offcanvas-header">
                        <div className="offcanvas-title" id="offcanvasMenuLabel">
                            <span
                                className={`pe-3 language ${language === "de" ? "underline" : ""}`}
                                onClick={(e) => onLanguageClick("de")}
                            >
                                de
                            </span>
                            <span
                                className={`pe-3 language ${language === "en" ? "underline" : ""}`}
                                onClick={(e) => onLanguageClick("en")}
                            >
                                en
                            </span>
                            <span
                                className={`pe-3 language ${language === "fr" ? "underline" : ""}`}
                                onClick={(e) => onLanguageClick("fr")}
                            >
                                fr
                            </span>
                        </div>
                        <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>
                    <div className="offcanvas-body">

                        <div className="accordion" id="accordion-information-nav">
                            <div className="accordion-item accordion-item-nav">
                                <h2 className="accordion-header" id="headingTwo">
                                    <button
                                        className="accordion-button collapsed accordion-button-nav"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                    >
                                        <label className="accordion-nav-button-text">
                                            {resources?.NavbarOpeningTime}
                                        </label>
                                    </button>
                                </h2>
                                <div id="collapseTwo" className="accordion-collapse collapse show" aria-labelledby="headingTwo" data-bs-parent="#accordion-information-tariffe">
                                    <div className="accordion-body accordion-body-nav">
                                        <ul className="list-unstyled">
                                            <li className="accordion-nav-sub">{resources?.NavbarOpeningTime1Title}</li>
                                            <br />
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime1Text1}</li>
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime1Text2}</li>
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime1Text3}</li>
                                            <br />
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime1Text4}</li>
                                        </ul>
                                        <span>&nbsp;</span>
                                        <ul className="list-unstyled">
                                            <li className="accordion-nav-sub">{resources?.NavbarOpeningTime2Title}</li>
                                            <br />
                                            {/*<li className="accordion-nav-text">{resources?.NavbarOpeningTime2Text1}</li>*/}
                                            {/*<li className="accordion-nav-text">{resources?.NavbarOpeningTime2Text2}</li>*/}
                                            {/*<li className="accordion-nav-text">{resources?.NavbarOpeningTime2Text3}</li>*/}
                                            {/*<li className="accordion-nav-text">{resources?.NavbarOpeningTime2Text4}</li>*/}
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime2Text5}</li>
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime2Text6}</li>
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime2Text7}</li>
                                        </ul>
                                        <span>&nbsp;</span>
                                        <ul className="list-unstyled">
                                            <li className="accordion-nav-sub">{resources?.NavbarOpeningTime3Title}</li>
                                            <br />
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime3Text1}</li>
                                        </ul>
                                        <span>&nbsp;</span>
                                        <ul className="list-unstyled">
                                            <li className="accordion-nav-sub">{resources?.NavbarOpeningTime4Title}</li>
                                            <br />
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime4Text1}</li>
                                        </ul>
                                        <span>&nbsp;</span>
                                        <ul className="list-unstyled">
                                            <li className="accordion-nav-sub">{resources?.NavbarOpeningTime5Title}</li>
                                            <br />
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime5Text1}</li>
                                            <li className="accordion-nav-text">{resources?.NavbarOpeningTime5Text2}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    )
}

export default Navbar